<template>
  <MuiForm
    v-model="formData"
    class="SignUpCompanyStep2 Step__form"
    @submit.native="handlerFormSubmit"
  >
    <h1
      class="Step__title h1 color-secondary"
    >
      {{ $t('Views.company_signup.step_2.hello', {name: data.firstName}) }}
    </h1>
    <h1
      class="Step__title h1 color-secondary"
    >
      {{ $t('Views.company_signup.step_2.title') }}
    </h1>
    <div
      class="Step__subtitle"
    >
      {{ $t('Views.company_signup.step_2.subtitle') }}
    </div>
    <!-- Admin Login -->
    <h3
      class="h3 color-secondary pb-3"
    >
      {{ $t('Views.company_signup.titles.company_details') }}
    </h3>

    <MuiInputLocation
      :google="google"
      :label="$t('Views.user_signup.step_4.hint.GB.address')"
      :placeholder="$t('Views.user_signup.step_4.hint.GB.address')"
      :value="data.companyAddress"
      :on-change="(e, v) => companyAddress(v)"
      :on-blur="(e, v) => companyAddress(v)"
      :required-address-components="[
        'route',
        'locality',
        'administrative_area_level_1',
        'administrative_area_level_2',
        'country',
        'postal_code'
      ]"
      :error-messages="{
        required: this.$t('Views.company_signup.errors.mandatory')
      }"
      required
      full-width
      name="companyAddress"
    />

    <MuiInputText
      :label="$t('Views.user_signup.step_4.hint.GB.additional_address')"
      :placeholder="$t('Views.user_signup.step_4.hint.GB.additional_address')"
      :value="data.extraCompanyAddress"
      :on-change="(e, v) => extraCompanyAddress(v)"
      full-width
      name="extraCompanyAddress"
      optional-text=""
    />

    <MuiSelect
      v-if="info.legalForms.length"
      :label="$t('Views.company_signup.fields.legal_form')"
      :placeholder="$t('Views.company_signup.fields.legal_form')"
      :value="data.legalForm"
      :on-change="(v) => legalForm(v)"
      :custom-error-messages="{
        empty: this.$t('Views.company_signup.errors.mandatory'),
      }"
      name="legalForm"
      required
      full-width
    >
      <MuiSelectItem
        v-for="item in info.legalForms"
        :key="item"
        :value="item"
        :title="item"
      >
        {{ item }}
      </MuiSelectItem>
    </MuiSelect>

    <MuiSelect
      v-if="info.sectorEntities.length"
      :label="$t('Views.company_signup.fields.sector_entity')"
      :placeholder="$t('Views.company_signup.fields.sector_entity')"
      :value="data.sectorEntity"
      :on-change="(v) => sectorEntity(v)"
      name="sectorEntity"
      object-label="name"
      object-value="internal_name"
      return-object
      full-width
    >
      <MuiSelectItem
        v-for="entity in info.sectorEntities"
        :key="entity.internal_name"
        :value="entity"
      >
        {{ entity.name }}
      </MuiSelectItem>
    </MuiSelect>

    <MuiSelect
      v-if="info.companySizes.length"
      :label="$t('Views.company_signup.fields.company_size')"
      :placeholder="$t('Views.company_signup.fields.company_size')"
      :value="data.companySize"
      :on-change="(v) => companySize(v)"
      object-label="label"
      object-value="value"
      name="companySize"
      return-object
      full-width
    >
      <MuiSelectItem
        v-for="size in info.companySizes"
        :key="size.value"
        :value="size"
        type="main"
      >
        {{ size.label }}
      </MuiSelectItem>
    </MuiSelect>

    <MuiButtonFlat
      submit
      class="Step__form__next-button"
    >
      {{ $t('Views.company_signup.actions.next') }}
    </MuiButtonFlat>
  </MuiForm>
</template>
<script>

import { mapState, mapMutations } from 'vuex';
import {
  MuiForm,
  MuiInputText,
  MuiButtonFlat,
  MuiSelect,
  MuiSelectItem,
  MuiInputLocation,
} from '@ubeeqo/motion-ui';
import { gmapApi as google } from 'vue2-google-maps';

import { COMPANY_MODULE } from '@/constants/modules';

export default {
  name: 'SignUpCompanyStep2View',
  components: {
    MuiForm,
    MuiInputText,
    MuiButtonFlat,
    MuiSelect,
    MuiSelectItem,
    MuiInputLocation,
  },
  data() {
    return {
      formData: {},
      linkAccount: false,
      loaded: false,
      userFromSpain: false,
    };
  },
  computed: {
    ...mapState(COMPANY_MODULE, {
      done: state => state.done,
      data: state => state.data,
      info: state => state.info,
    }),
    selectedCompanySize() {
      return this.info.companySizes.find(i => i.value === this.data.companySize);
    },
    google: () => google(),
    getCountryHintAddress() {
      return this.$t('Views.user_signup.step_4.hint.address');
    },
    getCountryHintAdditionalAddress() {
      return this.$t('Views.user_signup.step_4.hint.additional_address');
    },
  },
  watch: {
    formData(value) {
      if (value.valid) {
        this.doneStep('step2');
      } else {
        this.unDoneStep('step2');
      }
    },
  },
  mounted() {
    this.linkAccount = this.$route.query.linkAccount;
    if (!this.done.SignUpCompanyStep1) {
      this.$router.push('step1');
    }
  },
  methods: {
    ...mapMutations(COMPANY_MODULE, [
      'companyAddress',
      'extraCompanyAddress',
      'legalForm',
      'sectorEntity',
      'companySize',
      'companySizes',
      'doneStep',
      'unDoneStep',
      'updateStep',
    ]),
    handlerFormSubmit() {
      if (this.$data.formData.valid) {
        this.doneStep('step2');
        this.updateStep('step3');
        this.$router.push('./step3');
      } else {
        this.unDoneStep('step2');
        this.updateStep('step2');
      }
    },
  },
};
</script>
